import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const backendUrl = 'http://localhost:3001/api';

const TimelineItem: React.FC<{ title: string; date: string; subtitle?: string }> = ({ title, date, subtitle }) => (
  <div style={{ borderLeft: '3px solid #1976d2', paddingLeft: 12, marginBottom: 12 }}>
    <div style={{ fontWeight: 600 }}>{title}</div>
    <div style={{ color: '#555', fontSize: 12 }}>{new Date(date).toLocaleString()}</div>
    {subtitle && <div style={{ marginTop: 4 }}>{subtitle}</div>}
  </div>
);

const MerchantLifecycle: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [events, setEvents] = useState<any[]>([]);
  const [repayments, setRepayments] = useState<any[]>([]);

  useEffect(() => {
    if (!id) return;
    axios.get(`${backendUrl}/applications/${id}/events`).then(r => setEvents(r.data));
    axios.get(`${backendUrl}/applications/${id}/repayments`).then(r => setRepayments(r.data));
  }, [id]);

  return (
    <div style={{ padding: 16, maxWidth: 800 }}>
      <h2>Loan Lifecycle</h2>
      <div>
        <h4>Timeline</h4>
        {events.length === 0 && <div>No events available.</div>}
        {events.map(ev => (
          <TimelineItem key={ev.id} title={ev.eventType} date={ev.eventDate} subtitle={ev.amount ? `Amount: ${Number(ev.amount).toLocaleString('en-ZW')} ZiG` : undefined} />
        ))}
      </div>
      <div style={{ marginTop: 16 }}>
        <h4>Repayments</h4>
        {repayments.length === 0 && <div>No repayments recorded.</div>}
        {repayments.map(r => (
          <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
            <span>{new Date(r.paymentDate).toLocaleDateString()}</span>
            <span>{Number(r.amount).toLocaleString('en-ZW')} ZiG</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MerchantLifecycle;

